<template>
  <div class="PlaceHolder Section no-border">
    <svg
      width="202px"
      height="191px"
      viewBox="0 0 202 191"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          id="path-1"
          d="M109.5,88 L43.9903024,88 C27.4271157,88 14,74.5746452 14,58.0023172 L14,7.24705882 L86,7.24705882 L86,0 L133,0 L133,88 L109.5,88 Z"
        />
        <filter
          id="filter-2"
          x="-1.7%"
          y="-2.3%"
          width="103.4%"
          height="104.5%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="shadowSpreadInner1"
          />
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadInner1"
            result="shadowOffsetInner1"
          />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
            type="matrix"
            in="shadowInnerInner1"
          />
        </filter>
        <path
          id="path-3"
          d="M113,20 L113,58.9990158 C113,72.0637747 121.347759,83.1727758 133,87.2915752 L133,89 L29.9928856,89 C13.4282723,89 0,75.5733201 0,58.9990158 L0,20 L113,20 Z"
        />
        <filter
          id="filter-4"
          x="-1.1%"
          y="-2.2%"
          width="102.3%"
          height="104.3%"
          filterUnits="objectBoundingBox"
        >
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="shadowSpreadInner1"
          />
          <feOffset
            dx="0"
            dy="0"
            in="shadowSpreadInner1"
            result="shadowOffsetInner1"
          />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
            type="matrix"
            in="shadowInnerInner1"
          />
        </filter>
      </defs>
      <g
        id="Page-2"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-522.000000, -371.000000)"
        >
          <g
            id="NO-DATA-ICON"
            transform="translate(522.000000, 371.000000)"
          >
            <g
              id="Folder"
              transform="translate(0.000000, 34.000000)"
            >
              <g id="Combined-Shape">
                <use
                  fill="#FEE6C1"
                  fill-rule="evenodd"
                  xlink:href="#path-1"
                />
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-2)"
                  xlink:href="#path-1"
                />
                <use
                  stroke="#F5A623"
                  stroke-width="2"
                  xlink:href="#path-1"
                />
              </g>
              <g id="Combined-Shape">
                <use
                  fill="#FCF6E0"
                  fill-rule="evenodd"
                  xlink:href="#path-3"
                />
                <use
                  fill="black"
                  fill-opacity="1"
                  filter="url(#filter-4)"
                  xlink:href="#path-3"
                />
                <path
                  stroke="#F5A623"
                  stroke-width="2"
                  d="M112,21 L1,21 L1,58.9990158 C1,75.0192666 13.9787886,88 29.9928856,88 L132,88 L132,87.9901331 C120.077573,83.4668875 112,72.0029905 112,58.9990158 L112,21 Z M132.026042,88 L132.500968,88 L132.666731,88.2344069 C132.451966,88.1584926 132.238396,88.0803468 132.026042,88 Z"
                  stroke-linejoin="square"
                />
              </g>
              <path
                id="Path"
                d="M4.71142989,70.9506548 L113.350058,70.9506548 C113.350058,70.9506548 113.767641,72.5366991 116.211954,76.5231845 C118.656268,80.5096699 127.243793,87.0996008 127.243793,87.0996008 C127.243793,87.0996008 30.8599296,87.2876567 28.0593508,86.8844234 C25.2587721,86.4811902 19.7643209,86.7043181 12.7204637,81.0174842 C5.80241653,75.4322227 4.71142989,70.9506548 4.71142989,70.9506548 Z"
                fill="#FDEAC5"
              />
              <rect
                id="Rectangle-26"
                fill="#FED28E"
                x="93"
                y="5"
                width="34"
                height="3"
                rx="1.5"
              />
            </g>
            <rect
              id="Rectangle-22"
              stroke="#F5A623"
              stroke-width="2"
              fill="#FFFFFF"
              x="97"
              y="73"
              width="52"
              height="51"
            />
            <text
              id="?"
              font-family="ArialMT, Arial"
              font-size="29"
              font-weight="normal"
              fill="#F5A623"
            >
              <tspan
                x="115"
                y="109"
              >?</tspan>
            </text>
            <path
              id="Combined-Shape"
              d="M147.196993,127.733187 L158.26054,138.417129 L160.562888,136.114781 C161.73085,134.94682 163.629454,134.951784 164.803317,136.125647 L197.000378,168.322708 C201.881723,173.204053 201.882627,181.117373 197,186 C192.118446,190.881554 184.197275,190.874944 179.322708,186.000378 L147.125647,153.803317 C145.951685,152.629354 145.950428,150.727241 147.114781,149.562888 L150.481181,146.196489 L139.499388,135.591495 C131.433997,142.101859 121.172228,146 110,146 C84.0426168,146 63,124.957383 63,99 C63,73.0426168 84.0426168,52 110,52 C135.957383,52 157,73.0426168 157,99 C157,109.821427 153.342814,119.788673 147.196993,127.733187 Z M110,134 C129.329966,134 145,118.329966 145,99 C145,79.6700338 129.329966,64 110,64 C90.6700338,64 75,79.6700338 75,99 C75,118.329966 90.6700338,134 110,134 Z"
              stroke="#F5A623"
              stroke-width="2"
              fill="#FFFFFF"
            />
            <path
              id="Rectangle-23"
              d="M176.788582,144.297432 C176.788582,143.74026 177.232447,143.288582 177.788582,143.288582 L177.788582,143.288582 C178.340867,143.288582 178.788582,143.729885 178.788582,144.297432 L178.788582,179.279732 C178.788582,179.836905 178.344717,180.288582 177.788582,180.288582 L177.788582,180.288582 C177.236297,180.288582 176.788582,179.847279 176.788582,179.279732 L176.788582,144.297432 Z"
              fill="#F5A623"
              transform="translate(177.788582, 161.788582) rotate(-45.000000) translate(-177.788582, -161.788582) "
            />
            <path
              id="Rectangle-23"
              d="M149.899495,151.899495 C149.899495,151.34721 150.350774,150.899495 150.902795,150.899495 L174.896195,150.899495 C175.450302,150.899495 175.899495,151.34336 175.899495,151.899495 L175.899495,151.899495 C175.899495,152.45178 175.448216,152.899495 174.896195,152.899495 L150.902795,152.899495 C150.348687,152.899495 149.899495,152.45563 149.899495,151.899495 L149.899495,151.899495 Z"
              fill="#F5A623"
              transform="translate(162.899495, 151.899495) rotate(-45.000000) translate(-162.899495, -151.899495) "
            />
            <path
              id="Rectangle-23-Copy-2"
              d="M174.899495,176.899495 C174.899495,176.34721 175.350774,175.899495 175.902795,175.899495 L199.896195,175.899495 C200.450302,175.899495 200.899495,176.34336 200.899495,176.899495 L200.899495,176.899495 C200.899495,177.45178 200.448216,177.899495 199.896195,177.899495 L175.902795,177.899495 C175.348687,177.899495 174.899495,177.45563 174.899495,176.899495 L174.899495,176.899495 Z"
              fill="#F5A623"
              transform="translate(187.899495, 176.899495) rotate(-45.000000) translate(-187.899495, -176.899495) "
            />
            <path
              id="Rectangle-23"
              d="M150.522078,153.482233 C150.522078,152.929948 150.973357,152.482233 151.525378,152.482233 L175.518778,152.482233 C176.072885,152.482233 176.522078,152.926098 176.522078,153.482233 L176.522078,153.482233 C176.522078,154.034518 176.070799,154.482233 175.518778,154.482233 L151.525378,154.482233 C150.97127,154.482233 150.522078,154.038368 150.522078,153.482233 L150.522078,153.482233 Z"
              fill="#F5A623"
              opacity="0.451313406"
              transform="translate(163.522078, 153.482233) rotate(-45.000000) translate(-163.522078, -153.482233) "
            />
            <path
              id="Rectangle-23-Copy"
              d="M171.788582,149.297432 C171.788582,148.74026 172.232447,148.288582 172.788582,148.288582 L172.788582,148.288582 C173.340867,148.288582 173.788582,148.729885 173.788582,149.297432 L173.788582,184.279732 C173.788582,184.836905 173.344717,185.288582 172.788582,185.288582 L172.788582,185.288582 C172.236297,185.288582 171.788582,184.847279 171.788582,184.279732 L171.788582,149.297432 Z"
              fill="#F5A623"
              transform="translate(172.788582, 166.788582) rotate(-45.000000) translate(-172.788582, -166.788582) "
            />
            <circle
              id="Oval-5"
              stroke="#F5A623"
              stroke-width="3"
              fill="#FFFFFF"
              opacity="0.294836957"
              cx="179"
              cy="94"
              r="7"
            />
            <polygon
              id="Star"
              fill="#FDE5BF"
              points="83 15 77.1221475 18.0901699 78.2447174 11.545085 73.4894348 6.90983006 80.0610737 5.95491503 83 0 85.9389263 5.95491503 92.5105652 6.90983006 87.7552826 11.545085 88.8778525 18.0901699"
            />
            <polygon
              id="Polygon"
              stroke="#FDE5BF"
              fill="#FFFFFF"
              points="165.201581 30.5 168.355967 32.7917961 167.151099 36.5 163.252062 36.5 162.047194 32.7917961"
            />
            <circle
              id="Oval-7"
              fill="#FDE5BF"
              cx="61"
              cy="138"
              r="3"
            />
            <circle
              id="Oval-8"
              fill="#FFFFFF"
              opacity="0.761152627"
              cx="110"
              cy="99"
              r="34"
            />
            <path
              id="Oval-8-Copy"
              d="M89.5131517,111.812602 C89.1366638,112.2058 89.2438258,112.331471 89.7297763,112.086614 C89.7297763,112.086614 107.75735,104.327478 106.977709,83.3407635 C106.198069,62.3540485 87.3234763,56.2463325 87.3234763,56.2463325 C86.8096194,56.053128 86.7380631,56.1700286 87.1772798,56.5324389 C87.1772798,56.5324389 102.207157,67.945488 102.207157,83.6439207 C102.207157,99.3423534 89.5131517,111.812602 89.5131517,111.812602 Z"
              fill="#FFFFFF"
              transform="translate(96.945306, 84.182984) rotate(229.000000) translate(-96.945306, -84.182984) "
            />
          </g>
        </g>
      </g>
    </svg>
    <div v-if="searchedTerm.length !== 0">
      <h3>Cant find any data for "{{ searchedTerm }}"</h3>
    </div>
    <div v-else>
      <h2>{{ message.header }}</h2>
      <p>{{ message.message }}</p>
    </div>
  </div>
</template>

<script>
import Lang from '../../../lang/events-en';

export default {
  mixins: [Lang],
  props: {
    langKey: {
      default: 'campaigns',
      type: String,
    },
    search: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      searchedTerm: '',
    };
  },
  computed: {
    message() {
      return {
        header: Lang[this.langKey].noData.heading,
        message: Lang[this.langKey].noData.message,
      };
    },
  },
  mounted() {
    this.searchedTerm = this.search;
  },
};
</script>
<style type="text/css" lang="less">
  .PlaceHolder{
    text-align: center;
    margin-top: 50px;
  }
</style>
